import { environment } from '../../../environments/environment.local';

export const bookingUriTemplate = (bookingId?: string): string => {
  return `${environment.API.BOOKING_URI}/${bookingId}`;
};
